<template>
  <div class="row d-flex align-items-stretch">
      <div class="col-md-4 col-12 my-3 d-flex" v-for="portdata in portdatas" :key="portdata._id">
        <div class="blog-text p-3 w-100">
          <div class="my-2 text-center port-img-wrapper">
            <img :src="getImage(portdata.images)" @error="handleImgError" class="img-fluid img-thumbnail port-img" alt="Portfolio Image" />
          </div>

          <div class="port-info-content">
            <h6 class="m-0 p-0 th_data">{{ portdata.name ? portdata.name.th : '' }}</h6>

            <h6 class="m-0 p-0 en_data">{{ portdata.name ? portdata.name.en : '' }}</h6>

            <p class="small my-3 th_data" v-if="portdata.link && portdata.link.th != ''" v-html="portdata.link.th"></p>

            <p class="small my-3 en_data" v-if="portdata.link && portdata.link.en != ''" v-html="portdata.link.en"></p>

            <p class="small my-3 th_data" v-if="portdata.content && portdata.content.th != ''" v-html="'หน้าที่/ความรับผิดชอบ:<br />'+portdata.content.th"></p>

            <p class="small my-3 en_data" v-if="portdata.content && portdata.content.en != ''" v-html="'Responsibility:<br />'+portdata.content.en"></p>

            <p class="small my-3 th_data" v-if="portdata.technology && portdata.technology.th != ''" >Tech: {{ portdata.technology.th }}</p>

            <p class="small my-3 en_data" v-if="portdata.technology && portdata.technology.en != ''">Tech: {{ portdata.technology.en }}</p>

            <p class="small my-3 th_data" v-if="portdata.api && portdata.api.th != ''">API ภายนอก: {{ portdata.api.th }}</p>

            <p class="small my-3 en_data" v-if="portdata.api && portdata.api.en != ''">External API: {{ portdata.api.en }}</p>
          </div>
        </div>
      </div>
    </div>

</template>
  
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "PortfolioSegment",
  props: {
    cat: String,
    index: Number,
  },
  data() {
    return {
      portdatas: [] as any[],
      portdata: {
        _id: "",
        name: "",
        link: "",
        images: "",
        content: "",
        technology: "",
        api: "",
        category: "",
        order_show: "",
        discard: "",
        dateTimeCreated: "",
        dateTimeUpdated: "",
      },
      port_cat_url:
        (process.env.VUE_APP_DATA_URL || '') + "category_portfolio/" + this.cat,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    getImage(imgUrl: string) {
      if (!imgUrl || imgUrl.trim() === "" || imgUrl.toLowerCase() === "no image" || imgUrl.toLowerCase() === "no_image" || imgUrl.toLowerCase() === "noimage") {
        return require("@/assets/images/blank.jpg");
      }
      return imgUrl;
    },
    handleImgError(e: Event) {
      const target = e.target as HTMLImageElement;
      target.src = require("@/assets/images/blank.jpg");
    },
    fetchData() {
      fetch(this.port_cat_url)
        .then((res) => res.json())
        .then((res) => {
          this.portdatas = res.return;
          this.$emit("changeload", this.index);
        });
    },
  },
  watch: {
    "$i18n.locale": function (newVal: string, oldVal: string) {
      Array.from(document.querySelectorAll("." + oldVal + "_data")).forEach(
        (sh: any) => {
          sh.style.display = "none";
        }
      );
      Array.from(document.querySelectorAll("." + newVal + "_data")).forEach(
        (sh: any) => {
          sh.style.display = "block";
        }
      );
    },
  },
});
</script>

<style scoped>
.blog-text {
  display: flex;
  flex-direction: column;
  height: 600px;
  max-height: 600px;
  overflow: hidden;
}

.port-img-wrapper {
  height: 200px;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 6px;
}

.port-img {
  width: 100%;
  height: 100% !important;
  object-fit: cover;
}

.port-info-content {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 6px;
  margin-top: 8px;
}

/* Custom scrollbar */
.port-info-content::-webkit-scrollbar {
  width: 5px;
}

.port-info-content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.port-info-content::-webkit-scrollbar-thumb {
  background: rgba(42, 46, 17, 0.4);
  border-radius: 4px;
}

.port-info-content::-webkit-scrollbar-thumb:hover {
  background: rgba(42, 46, 17, 0.7);
}
</style>